import FieldProto from "../../proto/field-proto"
import FieldInputProto_ManagementPreview from "./render/management/management-preview"
import {GROUP_INFO} from "../../../gd/const/fields/field2-groups"
import {FieldFilterType} from "../../proto/types"
import SessionCustomField from "../../../model2/custom-field/session-custom-field";
import {FieldType} from "../../field-type";
import CustomFieldsV1 from "../../../gd/const/fields/custom-fields-v1";
import FieldAddress_ManagementFormCFV1 from "./render/management/management-form-cfv1";
import FieldAddress_PopoverMenu from "./components/popover/popover-menu";
import FieldAddress_PopoverOption from "./components/option/option";
import FieldConfig from "../../proto/field-config";
import FieldAddress_Editable from "./render/editable/editable";
import FieldAddress_InlineEditable from "./render/inline-editable/inline-editable";
import FieldAddress_View from "./render/view";
import FieldAddress_FormElementView from "./render/form-element-view";
import FieldAddress_FormElement from "./render/form-element";
import FieldAddress_AutomationTrigger from "./render/automation/automation-trigger";
import FieldAddress_AutomationConditionForm from "./render/automation/automation-condition";
import FieldAddress_AutomationActionForm from "./render/automation/automation-action";
import FieldAddress_ManagementForm from "./render/management/management-form";
import FieldAddress_ViewProperty from "./render/property"
import FieldAddress_ConditionForm from "./render/condition/condition"
import {FIELD_CONDITIONS_STRING, FieldAddress_filterFunc} from "../../conditions/string"

export default class FieldAddress extends FieldProto {

    // public trimValue        : boolean

    constructor(config: FieldConfig) {
        super(config);

        this.typeInteger        = CustomFieldsV1.type.ADDRESS
        this.typeLabel          = "Address"
        this.typeGroup          = GROUP_INFO
        this.typeDescription    = "Address input field"
        this.trimValue          = _.get(config,'trimValue', true)   // trim value in input forms

        this.filterType         = FieldFilterType.STRING
        this.icon               = 'i5-location'
        this.options            = _.get(config,'options',[]); // [{value, label, color},...]
        this.isSearchable       = true
        this.isFilterAvailable  = true

        this.conditionTypes     = FIELD_CONDITIONS_STRING

        this.formType           = 'input'

        this.components.PopoverMenu                     = FieldAddress_PopoverMenu
        this.components.PopoverOption                   = FieldAddress_PopoverOption

        this.renderComponents.view                      = FieldAddress_View

        this.renderComponents.managementPreview         = FieldInputProto_ManagementPreview
        this.renderComponents.managementForm            = FieldAddress_ManagementForm
        this.renderComponents.managementFormCFV1        = FieldAddress_ManagementFormCFV1

        this.renderComponents.editable                  = FieldAddress_Editable
        this.renderComponents.inlineEditable            = FieldAddress_InlineEditable

        this.renderComponents.formElement               = FieldAddress_FormElement
        this.renderComponents.formElementView           = FieldAddress_FormElementView
        this.renderComponents.automationTriggerForm     = FieldAddress_AutomationTrigger
        this.renderComponents.automationConditionForm   = FieldAddress_AutomationConditionForm
        this.renderComponents.automationActionForm      = FieldAddress_AutomationActionForm
        this.renderComponents.viewProperty              = FieldAddress_ViewProperty

        this.renderComponents.conditionForm             = FieldAddress_ConditionForm
        this.renderComponents.filterForm                = FieldAddress_ConditionForm

        this.filterFunc                                 = FieldAddress_filterFunc
    }

    static initFromCustomFieldV1(customFieldV1:SessionCustomField) {
        return new FieldAddress({
            fieldId         : customFieldV1.id,
            label           : customFieldV1.name,
            type            : FieldType.ADDRESS,
            fieldParams     : customFieldV1.params,
            fieldAccess     : customFieldV1.access
        })
    }

    getDisplayValue(value: any){

        if (!value) return null

        // Tut glupo sdelal. Eto dlya podderjki starix zapis
        return value?.place ? value.place.address : value?.address
    }

    getCsvValue(value:any) {
        const viewValue = this.getViewValue(value)

        return this.getDisplayValue(viewValue)
    }

    _getOption(value:any) {

        if (this.hasOptionWithNullValue || !_.isNil(value)) {
            const option = _.find(this.getOptions(), option => _.isEqual(option.value,  value))
            if (option) return option
        }

        return false
    }

    // used in automation for custom fields
    automationGetValuesForDescription(value:any) {
        const address = value?.place?.address
        return address ? [address] : []
    }

    /*** DATA FUNCTIONS ***/

    sortValue(value:any) {
        return value ? value.toLowerCase() : ''
    }

    searchValue(value:any) {return value ? value.toLowerCase() : ''}
}
